import { Accordion, AccordionDetails, AccordionSummary, Button, Stack, Typography } from '@mui/material';
import { IconChevronDown } from '@tabler/icons-react';

export function publicPage(path: string) {
    const local = ['localhost', '127.0.0.1'].includes(window.location.hostname);
    return (local ? `http://${window.location.hostname}:8134` : 'https://leadsmania.ru') + path;
}

export default function WorkspaceHelp() {
    const questions = [
        [
            'Чем новый кабинет отличается от текущего?',
            'Выберите поток в левом меню. У каждого потока свои лиды, воронка, описание бизнеса и база знаний.',
        ],
        [
            'Лид — это уже покупатель?',
            'Лид — найденный запрос с признаками спроса, а не гарантированная продажа. Проверьте контекст, актуальность и соответствие вашему предложению. Источник и этап работы видны в потоке.',
        ],
        [
            'С чего начать расчёт?',
            'Укажите доход от одной продажи после переменных затрат и конверсию из лида в продажу. Учитывайте цену лида, обработку и другие расходы. Если статистики нет, запускайте тест без обещания окупаемости.',
        ],
        [
            'Как работают пакеты и автопополнение?',
            'Доступность оплаты и автопополнения определяется сервером. Перед списанием должны быть видны сумма, объём, порог и условия. Выключенную возможность кабинет не выдаёт за подключённую.',
        ],
        [
            'Какие источники доступны?',
            'В настройках потока показан фактический статус каждого источника. Наличие типа источника в интерфейсе не означает, что он уже подключён или содержит свежие запросы.',
        ],
    ];
    return (
        <Stack spacing={3}>
            <Typography color="text.secondary">
                Разберитесь самостоятельно или обсудите запуск со специалистом.
            </Typography>
            <Stack
                direction="row"
                flexWrap="wrap"
                gap={1}
            >
                <Button
                    variant="contained"
                    component="a"
                    href={publicPage('/consultation/index.html')}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Обсудить задачу
                </Button>
                <Button
                    variant="outlined"
                    component="a"
                    href={publicPage('/blog/index.html')}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Блог и инструкции
                </Button>
                <Button
                    component="a"
                    href={publicPage('/about/index.html')}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    О ЛИДСМАНИИ
                </Button>
            </Stack>
            <div>
                {questions.map(([title, text]) => (
                    <Accordion
                        key={title}
                        disableGutters
                        elevation={0}
                    >
                        <AccordionSummary expandIcon={<IconChevronDown size={18} />}>
                            <Typography fontWeight={600}>{title}</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Typography
                                color="text.secondary"
                                variant="body2"
                            >
                                {text}
                            </Typography>
                        </AccordionDetails>
                    </Accordion>
                ))}
            </div>
            <Typography
                variant="body2"
                color="text.secondary"
            >
                При обращении укажите название потока и действие, на котором возник вопрос. Не отправляйте пароль и
                платёжные данные.
            </Typography>
        </Stack>
    );
}
